export const isDiscountValidForBundle = (discount) =>
  discount === 'Military' || discount === 'Event' || discount === 'Founders';
